import { atom, selector } from 'recoil';

import { unescapeHtml } from '@ecp/common/src/utils/htmlUtil';

import menuApi from '@bo-apis/system/menuApi';
import siteApi from '@bo-apis/system/siteApi';
// import { isCODomain } from '@bo-const/common/domain';

export const menusState = atom({
  key: 'menusState',
  default: selector({
    key: 'withDefaultMenus',
    get: async () => await getDefaultMenus(),
  }),
});

const getDefaultMenus = async () => {
  const isCODomain = window.location.href.includes(process.env.REACT_APP_CO_DOMAIN);

  const menuGroups = [];
  const menuUrls = {};
  const { result } = await menuApi.getBookmarkMenu({ skipSpinner: true });
  const baseBookmarkMenus = JSON.parse(unescapeHtml(result?.bookmarkMenuContents || '[]'));
  const { result: menuList } = isCODomain
    ? await menuApi.getLnbCoMenuList({ skipSpinner: true })
    : await menuApi.getLnbMenuList({ skipSpinner: true });

  const menus = menuList.reduce((acc, cur) => {
    const { menuNumber, upperMenuNumber, menuUrl } = cur;

    if (acc[menuNumber]) {
      acc[menuNumber] = { ...cur, menus: acc[menuNumber].menus };
    } else {
      acc[menuNumber] = { ...cur, menus: [] };
    }

    if (upperMenuNumber?.length > 0 && acc[upperMenuNumber]) {
      acc[upperMenuNumber].menus.push(menuNumber);
    } else if (upperMenuNumber?.length > 0 && !acc[upperMenuNumber]) {
      acc[upperMenuNumber] = { menus: [] };
    } else {
      menuGroups.push(menuNumber);
    }

    if (menuUrl?.length > 0) {
      menuUrls[menuUrl] = menuNumber;
    }

    return acc;
  }, {});

  const filteredBookmarkMenus = baseBookmarkMenus
    .map((bookmarkMenuNumber) => {
      if (menus[bookmarkMenuNumber]) {
        menus[bookmarkMenuNumber].isBookmark = true;
        return bookmarkMenuNumber;
      } else {
        return undefined;
      }
    })
    .filter((bookmarkMenuNumber) => bookmarkMenuNumber);

  return {
    menus,
    menuUrls,
    menuGroups,
    bookmarkMenus: filteredBookmarkMenus,
  };
};

export const alertDialogState = atom({
  key: 'boAlertDialogState',
  default: {
    open: false,
    message: '',
    onConfirm: () => {},
  },
});

export const confirmDialogState = atom({
  key: 'boConfirmDialogState',
  default: {
    open: false,
    message: '',
    onConfirm: () => {},
    onClose: () => {},
  },
});

export const toastState = atom({
  key: 'boToastState',
  default: [],
});

export const pageTitleState = atom({
  key: 'pageTitleState',
  default: '',
});

export const pageTooltipState = atom({
  key: 'pageTooltipState',
  default: undefined,
});

export const contentsUtilityState = atom({
  key: 'contentsUtilityState',
  default: false,
});

export const pageBackPathState = atom({
  key: 'pageBackPathState',
  default: '/',
});

export const siteState = atom({
  key: 'siteState',
  default: selector({
    key: 'withDefaultSite',
    get: async () => {
      const { result } = await siteApi.getSiteMgmtList({ skipSpinner: true });
      return result;
    },
  }),
});

export const allSiteSimpleState = atom({
  key: 'allSiteSimpleState',
  default: selector({
    key: 'withDefaultAllSiteSimple',
    get: async () => {
      const { result } = await siteApi.getAllSiteSimpleList({ skipSpinner: true });
      return result;
    },
  }),
});

export const subsidiaryState = atom({
  key: 'subsidiaryState',
  default: selector({
    key: 'withDefaultSubsidiary',
    get: async () => {
      const { result } = await siteApi.getSubsidiaryCompanyList({ skipSpinner: true });
      return result;
    },
  }),
});

export const allSubsidiaryState = atom({
  key: 'allSubsidiaryState',
  default: selector({
    key: 'withDefaultAllSubsidiary',
    get: async () => {
      const { result } = await siteApi.getAllSubsidiaryCompanyList({ skipSpinner: true });
      return result;
    },
  }),
});
